export enum QuestionnaireStepStatus {
  DISABLED = "disabled",
  PENDING = "pending",
  SUBMITTED = "submitted"
}
